<template>
  <div class="wrap" :class="{ disabled: $root.previewedProject }">
    <div class="content-block">
      <Header/>
      <Main/>
    </div>
  </div>
</template>

<script>
  import Header from './Header';
  import Main from './Main';

  export default {
    name: 'ContentBlock',
    components: { Main, Header },
  };
</script>

<style lang="less" scoped>
  @import (reference) '../shared.less';

  .wrap {
    width: 100%;
    height: 100%;
    z-index: @z-layers[content-block];
    transform: scale(1);
    filter: brightness(100%) grayscale(0%);
    transition-property: transform, filter;
    transition-duration: @transition-durations[main-block];
    transition-timing-function: @easing-functions[ease-out-cubic];

    [prefers-reduced-motion] & {
      transform: unset;
      transition-property: filter;
    }

    &.disabled {
      transform: scale(0.9);
      filter: brightness(0%) grayscale(100%);
      pointer-events: none;

      [prefers-reduced-motion] & {
        transform: unset;
      }
    }
  }

  .content-block {
    background-color: @colors[background];
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    @media @vertical {
      overflow: initial;
      overflow-x: scroll;
      -webkit-overflow-scrolling: touch;
      .hide-scrollbar();
    }
  }
</style>
